import {
  Action,
  ThunkAction,
  configureStore,
  PreloadedState,
  combineReducers,
} from '@reduxjs/toolkit';
import authReducer from 'stores/auth/authSlice';
import userReducer from 'stores/user/userSlice';
import adminReducer from 'stores/admin/adminSlice';
import PatientsReducer from 'stores/patients/patientsSlice';
import TimeslotsReducer from 'stores/agenda/timeslotsSlice';
import authMiddleware from './authMiddleware';

export const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  admin: adminReducer,
  patients: PatientsReducer,
  timeslots: TimeslotsReducer,
});
export type RootState = ReturnType<typeof rootReducer>;

export const setupStore = (preloadedState?: PreloadedState<RootState>) => configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authMiddleware),
  reducer: rootReducer,
  preloadedState,
});

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
